module.exports = __webpack_public_path__ + "static/media/refresh-cw.4456b946.svg";